var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiberyusUstagrup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 29,
    viewBox: "0 0 94 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_8194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4274 25.3143V28.8474H32.8804L32.7165 28.1339C32.2433 28.7633 31.4789 29.0032 30.0806 29.0032C27.2626 29.0032 26.5952 27.8816 26.5952 25.4109C26.5952 24.2301 26.7894 23.4294 27.3596 22.9807C28.0118 22.4542 29.0522 22.2236 30.5841 22.2236C33.2049 22.2236 34.4274 22.8623 34.4274 24.4108H32.2949C32.2949 23.5665 31.7398 23.1708 30.666 23.1708C28.9552 23.1708 28.94 23.9466 28.94 25.7131C28.94 27.3239 29.1857 28.0124 30.5507 28.0124C31.8035 28.0124 32.2282 27.5731 32.2282 26.573V26.3487H30.6508V25.3143H34.4274Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4171 27.8816C45.4505 28.3022 45.581 28.6044 46.036 28.8474H43.3332C43.1694 28.5702 43.1391 28.2461 43.1209 27.8411L43.0875 27.1588V26.9874C43.0875 26.1431 42.4202 26.006 40.7913 26.006H40.0087V28.8506H37.8125V22.3701H41.8984C44.3585 22.3701 45.3838 22.8624 45.3838 24.0681C45.3838 24.9124 44.7801 25.4047 43.6578 25.4919C45.3353 25.7256 45.2867 26.1898 45.3504 27.0248L45.4141 27.8847L45.4171 27.8816ZM41.3312 25.1056C42.6507 25.1056 43.0875 24.8657 43.0875 24.1398C43.0875 23.4138 42.5173 23.2705 41.134 23.2705H40.0117V25.1056H41.3312Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2465 22.3669V26.8378C56.2465 27.4578 56.2131 27.9251 55.6428 28.3208C54.9906 28.7694 53.9168 29 52.4183 29C49.5033 29 48.5933 28.3706 48.5933 26.8378V22.3669H50.8713V26.735C50.8713 27.6322 51.1474 28.0186 52.4517 28.0186C53.7561 28.0186 53.9987 27.6229 53.9987 26.7163V22.3638H56.2465V22.3669Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6538 22.3669C66.0471 22.3669 67.0572 22.8841 67.0572 24.202C67.0572 25.5199 65.9348 26.0963 63.6234 26.0963H61.9611V28.8442H59.6982V22.3638H63.6538V22.3669ZM62.856 25.2021C64.2392 25.2021 64.7761 24.9622 64.7761 24.2269C64.7761 23.4511 64.2392 23.2704 62.8863 23.2704H61.8944V25.2021H62.856Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0784 5.64857H65.8256L69.3746 0.887939H55.5425V19.7217H61.0784V5.64857Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6328 0.887939H51.2263L47.8198 5.64857H54.6328V0.887939Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7266 0.887939V11.509C18.7266 13.2849 17.3221 14.7243 15.5961 14.7243H8.7923C7.06328 14.7243 5.66187 13.2849 5.66187 11.509V0.887939H0.326172V11.8143C0.326172 16.1793 3.77208 19.7217 8.02183 19.7217H16.3666C20.6164 19.7217 24.0623 16.1824 24.0623 11.8143V0.887939H18.7266Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4748 2.00956L93.3261 19.7217H71.5678L74.9743 13.4843H82.4485L78.4869 7.63633C78.0592 7.08487 77.2372 7.11603 76.8519 7.69864L69.3747 19.7217H62.0127L73.9126 2.04071C75.7387 -0.666742 79.6305 -0.685436 81.4778 2.00644",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0148 11.6181C49.2241 12.2412 49.3394 12.9328 49.3394 13.6557V14.2414C49.3394 17.0423 46.9369 19.3136 44.7923 19.3136H25.3394L28.673 14.8271H43.394C44.1159 14.8271 44.6983 14.2258 44.6983 13.4843V12.9609C44.6983 12.2194 44.1159 11.6181 43.394 11.6181H31.2302C28.3788 11.6181 26.0643 9.34679 26.0643 6.54275V5.96013C26.0643 3.1561 28.3758 0.887939 31.2302 0.887939H48.948L44.9956 5.62677H32.5739C31.852 5.62677 31.2635 6.22496 31.2635 6.96959V6.99451C31.2635 7.73603 31.852 8.33734 32.5739 8.33734H44.8318C46.2089 8.33734 48.2504 8.91684 49.0148 11.6181Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_8194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 29,
    fill: "white",
    transform: "translate(0.326172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberyusUstagrup);
export default __webpack_public_path__ + "static/media/liberyus-ustagrup.222d29edfefc1c3321b3d47d552f95c1.svg";
export { ForwardRef as ReactComponent };